export default (siteName) => [
    {
        path: 'payment',
        name: 'payment',
        component: () => import('../components/dashboard/Payment/PaymentPage.vue'),
        meta: {
            title: `請款單${siteName}`,
        },
    },
    {
        path: 'payment/add',
        name: 'payment-add',
        component: () => import('../components/dashboard/Payment/PaymentEditPage.vue'),
        meta: {
            title: `新增請款單${siteName}`,
            activeMenu: 'payment',
        },
    },
    {
        path: 'payment/:sno/edit',
        name: 'payment-edit',
        component: () => import('../components/dashboard/Payment/PaymentEditPage.vue'),
        meta: {
            title: `修改請款${siteName}`,
            activeMenu: 'payment',
        },
    },
    {
        path: 'payment/:sno',
        name: 'payment-detail',
        component: () => import('../components/dashboard/Payment/PaymentPage.vue'),
        meta: {
            title: `請款明細${siteName}`,
            activeMenu: 'payment',
        },
    },
    {
        path: 'payment-pdf/:sno',
        name: 'payment-pdf',
        component: () => import('../components/dashboard/Payment/PaymentPDFPage.vue'),
        meta: {
            title: `請款單列印${siteName}`,
            activeMenu: 'payment',
        },
    },
];
